import {
	AfterViewInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ElementRef,
	OnInit,
	Renderer2,
	ViewChild
} from '@angular/core';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import * as objectPath from 'object-path';
// Layout
import { LayoutConfigService, MenuAsideService, MenuOptions, OffcanvasOptions } from '../../../core/_base/layout';
import { HtmlClassService } from '../html-class.service';
import { AttendanceApiService } from 'src/app/Services/attendance.service';
import { OtherApiService } from 'src/app/Services/other.service';
import { UtilsService } from 'src/app/Services/utils.service';

@Component({
	selector: 'kt-aside-left',
	templateUrl: './aside-left.component.html',
	styleUrls: ['./aside-left.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AsideLeftComponent implements OnInit {

	@ViewChild('asideMenu', {static: true}) asideMenu: ElementRef;
	entityPreferences = JSON.parse(localStorage.getItem('entityPreferences'));
	currentRouteUrl = '';
	insideTm: any;
	outsideTm: any;
	isSliderOpen = false;
	userType = localStorage.getItem('userType')
	userId = localStorage.getItem('userId');
	menuCanvasOptions: OffcanvasOptions = {
		baseClass: 'kt-aside',
		overlay: true,
		closeBy: 'kt_aside_close_btn',
		toggleBy: {
			target: 'kt_aside_mobile_toggler',
			state: 'kt-header-mobile__toolbar-toggler--active'
		}
	};

	menuOptions: MenuOptions = {
		// vertical scroll
		scroll: null,

		// submenu setup
		submenu: {
			desktop: {
				// by default the menu mode set to accordion in desktop mode
				default: 'dropdown',
				// whenever body has this class switch the menu mode to dropdown
				state: {
					body: 'kt-aside--minimize',
					mode: 'dropdown'
				}
			},
			tablet: 'accordion', // menu set to accordion in tablet mode
			mobile: 'accordion' // menu set to accordion in mobile mode
		},

		// accordion setup
		accordion: {
			expandAll: false // allow having multiple expanded accordions in the menu
		}
	};
	entity :any= JSON.parse(localStorage.getItem('entityData'));
	showMessage: boolean;
	primaryColour:any
	displayNames:any={};
	schoolDiary: any;
	parentHover: boolean = false;
	parentItem: any;
	item: any = null;
	userPreferences: any={};
	favourites: any=[];
	hoveredMenuId: any = null;
	/**
	 * Component Conctructor
	 *
	 * @param htmlClassService: HtmlClassService
	 * @param menuAsideService
	 * @param layoutConfigService: LayouConfigService
	 * @param router: Router
	 * @param render: Renderer2
	 * @param cdr: ChangeDetectorRef
	 */
	constructor(
		public htmlClassService: HtmlClassService,
		public menuAsideService: MenuAsideService,
		public layoutConfigService: LayoutConfigService,
		private router: Router,
		private render: Renderer2,
		private cdr: ChangeDetectorRef,
		private attendanceService:AttendanceApiService,
		private service : OtherApiService,
		private util:UtilsService
	) {
	}



	ngOnInit() {
		this.primaryColour = this.service.passColour()
		this.userPreferences = JSON.parse(this.util.getItem('userPreferences') || '{}');
		if(this.userPreferences.favourites && this.userPreferences.favourites.length>0)
		{
			this.favourites = this.userPreferences.favourites
		} else {
			this.userPreferences = {favourites: []}
		}
		if(this.entityPreferences && this.entityPreferences.displayNames){
			this.displayNames = {
				schoolDiary : this.entityPreferences.displayNames.filter(item => item.value == 'schoolDiary')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'schoolDiary')[0].name : 'School Diary',
				event : this.entityPreferences.displayNames.filter(item => item.value == 'event')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'event')[0].name : 'Events',
				partnerInstitute : this.entityPreferences.displayNames.filter(item => item.value == 'partnerInstitute')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'partnerInstitute')[0].name : 'Partner Institute',
				sharePoint : this.entityPreferences.displayNames.filter(item => item.value == 'sharePoint')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'sharePoint')[0].name : 'Share Point',
				course : this.entityPreferences.displayNames.filter(item => item.value == 'course')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'course')[0].name : 'Class',
				greenSheet : this.entityPreferences.displayNames.filter(item => item.value == 'greenSheet')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'greenSheet')[0].name : 'Green Sheet',
				issuedBooks:this.entityPreferences.displayNames.filter(item => item.value == 'issuedBooks')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'issuedBooks')[0].name : 'Issued Books',
				seminar:this.entityPreferences.displayNames.filter(item => item.value == 'seminar')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'seminar')[0].name : 'Seminar',
				classTest:this.entityPreferences.displayNames.filter(item => item.value == 'classTest')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'classTest')[0].name : 'Class Test',
				lesson:this.entityPreferences.displayNames.filter(item => item.value == 'lesson')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'lesson')[0].name : 'Lesson',
				studentQuery:this.entityPreferences.displayNames.filter(item => item.value == 'studentQuery')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'studentQuery')[0].name : 'Student Queries',
				advanced: this.entityPreferences.displayNames.filter(item => item.value == 'advanced')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'advanced')[0].name : 'Advanced',
			};
		}

		if(this.entity && this.entity.paymentDueMessage){
			this.showMessage = true;
		}else{
			this.showMessage = false;
		}
		this.currentRouteUrl = this.router.url.split(/[?#]/)[0];
		this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe(event => {
				this.currentRouteUrl = this.router.url.split(/[?#]/)[0];
				this.cdr.markForCheck();
			});

		const config = this.layoutConfigService.getConfig();

		if (objectPath.get(config, 'aside.menu.dropdown') !== true && objectPath.get(config, 'aside.self.fixed')) {
			this.render.setAttribute(this.asideMenu.nativeElement, 'data-ktmenu-scroll', '1');
		}

		if (objectPath.get(config, 'aside.menu.dropdown')) {
			this.render.setAttribute(this.asideMenu.nativeElement, 'data-ktmenu-dropdown', '1');
			// tslint:disable-next-line:max-line-length
			this.render.setAttribute(this.asideMenu.nativeElement, 'data-ktmenu-dropdown-timeout', objectPath.get(config, 'aside.menu.submenu.dropdown.hover-timeout'));
		}
	}
	isRouteInSubmenu(submenu: any[], favourites: any[]):any {
		for (let subItem of submenu) {
			// Check if the current item's route is in favourites
			subItem.fav=false
			if (subItem.page && favourites.some(item => item.name === subItem.title)) {
				subItem.fav=true
				// return true;
			}
			// If there's a nested submenu, search recursively
			 if (subItem.submenu && this.isRouteInSubmenu(subItem.submenu, favourites)) {
				subItem.fav=true

			}
		}
		// return false;
	}
	checkIsFav()
	{		//console.log(this.item,this.favourites)
		this.isRouteInSubmenu(this.item.submenu, this.favourites);
	}

	/**
	 * Check Menu is active
	 * @param item: any
	 */
	isMenuItemIsActive(item): boolean {
		if (item.submenu && this.item == null) {
			return this.isMenuRootItemIsActive(item);
		}
		if (item.submenu && this.item == item) {
			return true
		}

		if (!item.page) {
			return false;
		}

		return this.currentRouteUrl.indexOf(item.page) !== -1 && this.item == null;
	}

	/**
	 * Check Menu Root Item is active
	 * @param item: any
	 */
	isMenuRootItemIsActive(item): boolean {
		let result = false;

		for (const subItem of item.submenu) {
			result = this.isMenuItemIsActive(subItem);
			if (result) {
				return true;
			}
		}

		return false;
	}

	/**
	 * Use for fixed left aside menu, to show menu on mouseenter event.
	 * @param e Event
	 */
	mouseEnter(item,parentItem) {
		if(window.innerWidth>750){
		// check if the left aside menu is fixed
			if (this.outsideTm) {
				clearTimeout(this.outsideTm);
				this.outsideTm = null;
			}

			this.insideTm = setTimeout(() => {
				// if the left aside menu is minimized
				if (document.body.classList.contains('kt-aside--minimize') && window.innerWidth>768) {
					// show the left aside menu

					this.render.removeClass(document.body, 'kt-aside--minimize');
					this.render.addClass(document.body, 'kt-aside--minimize-hover');
				}
			}, 50);
		this.item = item;
		this.parentItem = parentItem
		this.checkIsFav()
		this.cdr.detectChanges()
	}else{
		// this.item = item;
		this.item = { ...item };
		this.parentItem = { ...parentItem }
		this.checkIsFav()
		this.cdr.markForCheck();
		return null
	}
	}
	trackByFn(index: number, item: any): any {
		return item.id || index; // Use a unique identifier or fallback to index
	  }
	favAction(subchild)
	{
		let flag = false
		console.log(subchild.title)
		if(subchild.title.includes('Report') || this.util.staticFavouriteList.includes(subchild.title) || subchild.title==='Result At A Glance')
		{
			flag = true
		}
		let newObj= {
			name : subchild.title,
			pageType: flag? 'report' : 'action',
			route: subchild.page,
			}
		const index = this.favourites.findIndex(item => item.name === subchild.title);

		if (index !== -1) {
		// Item exists, so remove it
		this.favourites.splice(index, 1);
		}else{
			this.favourites.push(newObj)
		}

		this.userPreferences.favourites = this.favourites
		this.userPreferences.user = this.userId
		this.service.editUserPreferences(this.userPreferences)
		.subscribe(res=>{
			this.util.updateItem('userPreferences',this.userPreferences);
			if(index!==-1){
			this.util.alertSpecialMessage('Page has been removed from favourites successfully')
			}else{
				this.util.alertSpecialMessage('Page has been added to favourites successfully')
			}
			this.checkIsFav()
			this.cdr.detectChanges()
		},err=>{
			this.util.errmsg(err)
		})
	}
	/**
	 * Use for fixed left aside menu, to show menu on mouseenter event.
	 * @param e Event
	 */
	mouseLeave(e: Event) {
		if (document.body.classList.contains('kt-aside--fixed')) {
			if (this.insideTm) {
				clearTimeout(this.insideTm);
				this.insideTm = null;
			}

			if (this.outsideTm) {
				clearTimeout(this.outsideTm);
				this.outsideTm = null;
			}
			this.outsideTm = setTimeout(() => {
				// if the left aside menu is expand
				if (document.body.classList.contains('kt-aside--minimize-hover')
					//  && typeof KTUtil !== 'undefined' && KTUtil.isInResponsiveRange('desktop')
					) {
					// hide back the left aside menu
					this.render.removeClass(document.body, 'kt-aside--minimize-hover');
					this.render.addClass(document.body, 'kt-aside--minimize');
				}

				if(!KTUtil.isInResponsiveRange('desktop')){
					this.closeAside();
				}
			}, 100);
		}
		// this.item = null
	}

	/**
	 * Returns Submenu CSS Class Name
	 * @param item: any
	 */
	getItemCssClasses(item) {
		let classes = 'kt-menu__item';

		if (objectPath.get(item, 'submenu')) {
			classes += ' kt-menu__item--submenu';
		}

		if (!item.submenu && this.isMenuItemIsActive(item) && this.item == null) {
			classes += ' kt-menu__item--active kt-menu__item--here';
		}

		if (item.submenu && this.isMenuItemIsActive(item)) {
			classes += ' kt-menu__item--open kt-menu__item--here';
		}
		if (item.submenu && this.item == item) {
			classes += ' kt-menu__item--active kt-menu__item--here';
		}

		// custom class for menu item
		const customClass = objectPath.get(item, 'custom-class');
		if (customClass) {
			classes += ' ' + customClass;
		}

		if (objectPath.get(item, 'icon-only')) {
			classes += ' kt-menu__item--icon-only';
		}

		return classes;
	}

	getItemAttrSubmenuToggle(item) {
		let toggle = 'hover';
		if (objectPath.get(item, 'toggle') === 'click') {
			toggle = 'click';
		} else if (objectPath.get(item, 'submenu.type') === 'tabs') {
			toggle = 'tabs';
		} else {
			// submenu toggle default to 'hover'
		}

		return toggle;
	}

	isExternalLink(item: any): boolean {
		return false;
	}

	closeAside(){
		this.attendanceService.filterData.next(null)
		var ua = navigator.userAgent;
		// if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua)){
			document.getElementById('kt_aside').classList.remove("kt-aside--on")
			document.querySelector('.kt-aside-overlay').setAttribute("style", "display:none;")
			document.querySelector('body').classList.remove("kt-aside--on")
		// }
		document.querySelector('.kt-menu__item--open').classList.remove('kt-menu__item--open')
	}
	getIconSrc(title: string, isActive: boolean): string | null {
		const iconMap: { [key: string]: { active: string, inactive: string } } = {
		  'Dashboard': {
			active: 'https://cdn.lordicon.com/wmwqvixz.json',
			inactive: 'https://cdn.lordicon.com/cnpvyndp.json'
		  },
		  'Employee Portal': {
			active: 'https://cdn.lordicon.com/lxrsqlrx.json',
			inactive: 'https://cdn.lordicon.com/ppyvfomi.json'
		  },
		  'Student': {
			active: "https://cdn.lordicon.com/hrjifpbq.json",
			inactive: "https://cdn.lordicon.com/kthelypq.json"
		  },
		 'Student List V2': {
			active: "https://cdn.lordicon.com/hrjifpbq.json",
			inactive: "https://cdn.lordicon.com/kthelypq.json"
		  },
		  'Fee': {
			active: "https://cdn.lordicon.com/hwxmpvjm.json",
			inactive: "https://cdn.lordicon.com/abvvebgo.json"
		  },
		  'Accounting': {
			active:  "https://cdn.lordicon.com/caaolypd.json" ,
			inactive: "https://cdn.lordicon.com/rguiapej.json"
		  },
		  'Users': {
			active: "https://cdn.lordicon.com/hrjifpbq.json",
			inactive: "https://cdn.lordicon.com/kthelypq.json"
		  },
		  'Bulk Operations': {
			active: "https://cdn.lordicon.com/ddvangig.json",
			inactive: "https://cdn.lordicon.com/zxeeibtg.json"

		  },
		  'FrontDesk': {
			active: "https://cdn.lordicon.com/iazmohzf.json",
			inactive: "https://cdn.lordicon.com/kddybgok.json"

		  },
		  'Attendance': {
			active: "https://cdn.lordicon.com/wmlleaaf.json",
			inactive: "https://cdn.lordicon.com/abfverha.json"
		  },
         'Attendance Old': {
			active: "https://cdn.lordicon.com/wmlleaaf.json",
			inactive: "https://cdn.lordicon.com/abfverha.json"
		  },
		//   'Attendance New': {
		// 	active: "https://cdn.lordicon.com/wmlleaaf.json",
		// 	inactive: "https://cdn.lordicon.com/abfverha.json"
		//   },
		  'Attendance V3': {
			active: "https://cdn.lordicon.com/wmlleaaf.json",
			inactive: "https://cdn.lordicon.com/abfverha.json"
		  },
		  'HRM': {
			active: "https://cdn.lordicon.com/nebjzmnm.json",
			inactive: "https://cdn.lordicon.com/ivugxnop.json"
		  },
		  'Examination': {
			active: "https://cdn.lordicon.com/yrbmguoo.json",
			inactive: "https://cdn.lordicon.com/zrtfxghu.json"
		  },
		  'Insights': {
			active: "https://cdn.lordicon.com/uwinmnkh.json",
			inactive: "https://cdn.lordicon.com/whrxobsb.json"
		  },
		  'Learning Management': {
			active: "https://cdn.lordicon.com/wkyvrqoh.json",
			inactive: "https://cdn.lordicon.com/sqopewut.json"
		  },
		  'Advanced': {
			active: 'https://cdn.lordicon.com/kbjyaswv.json',
			inactive: "https://cdn.lordicon.com/lnnwjlfw.json"
		  },
		  'Analytics': {
			active: "https://cdn.lordicon.com/kbjyaswv.json",
			inactive: "https://cdn.lordicon.com/whrxobsb.json"
		  },
		  'Library': {
			active: "https://cdn.lordicon.com/omiqopzf.json",
			inactive: "https://cdn.lordicon.com/zyzoecaw.json"
		  },
		  [`${this.displayNames.lesson}`]: {
			active: "https://cdn.lordicon.com/ikuclkud.json",
			inactive: "https://cdn.lordicon.com/vmmgmkjz.json"
		  },
		  'Admission': {
			active: "https://cdn.lordicon.com/ziiscpji.json",
			inactive: "https://cdn.lordicon.com/tsndvcpl.json"
		  },
		'Admission V2': {
			active: "https://cdn.lordicon.com/ziiscpji.json",
			inactive: "https://cdn.lordicon.com/tsndvcpl.json"
		  },
		  'Communication': {
			active: "https://cdn.lordicon.com/ysfeiqhs.json",
			inactive: "https://cdn.lordicon.com/wcheggay.json"
		  },
		  'Communication V2': {
			active: "https://cdn.lordicon.com/ysfeiqhs.json",
			inactive: "https://cdn.lordicon.com/wcheggay.json"
		  },
		  'Feedback From Student': {
			active: "https://cdn.lordicon.com/oiiqgosg.json",
			inactive: "https://cdn.lordicon.com/prjooket.json"
		  },
		  'School Diary': {
			active: "https://cdn.lordicon.com/oiiqgosg.json",
			inactive: "https://cdn.lordicon.com/prjooket.json"
		  },
		  'Share Point': {
			active: "https://cdn.lordicon.com/boyoxams.json",
			inactive: "https://cdn.lordicon.com/ercyvufy.json"
		  },
		  'Expense Management': {
			active: "https://cdn.lordicon.com/gjjvytyq.json",
			inactive: "https://cdn.lordicon.com/ciawvzjk.json"
		  },
		  [this.displayNames.schoolDiary]: {
			active: "https://cdn.lordicon.com/nrwmoety.json",
			inactive: "https://cdn.lordicon.com/hmjvwxlf.json"
		  },
		  'Transport': {
			active: "https://cdn.lordicon.com/pjhvbwaw.json",
			inactive: "https://cdn.lordicon.com/epddlowa.json"
		  },
		  'Gallery': {
			active: "https://cdn.lordicon.com/ivlugcch.json",
			inactive:"https://cdn.lordicon.com/yacxrrtc.json"
		  },
		  'Hostel': {
			active: "https://cdn.lordicon.com/mjcariee.json",
			inactive: "https://cdn.lordicon.com/jkgunhbs.json"
		  },
		  'Entity List': {
			active: "https://cdn.lordicon.com/wanmylrs.json",
			inactive: "https://cdn.lordicon.com/odgbakbe.json"

		  },
		  'Billing': {
			active: "https://cdn.lordicon.com/rwtswsap.json",
			inactive: "https://cdn.lordicon.com/ijahpotn.json"
		  },
		  'Pdf Template': {
			active: "https://cdn.lordicon.com/hpthzadk.json",
			inactive: "https://cdn.lordicon.com/asmnmhaf.json"
		  },
		  'Excel Template': {
			active: "https://cdn.lordicon.com/reegdtnp.json",
			inactive: "https://cdn.lordicon.com/ahoskycx.json"
		  },
		  'White Labelling': {
			active: "https://cdn.lordicon.com/tdhtomee.json",
			inactive: "https://cdn.lordicon.com/gboqysvk.json"
		  },
		  'FAQ': {
			active: "https://cdn.lordicon.com/ayhtotha.json",
			inactive: "https://cdn.lordicon.com/fdxqrdfe.json" 
		  },
		  'Cron Logs': {
			active: "https://cdn.lordicon.com/ayhtotha.json",
			inactive: "https://cdn.lordicon.com/fdxqrdfe.json"
		  },
		  'Social Media':{
			active:'https://cdn.lordicon.com/vqhlecvy.json',
			inactive:'https://cdn.lordicon.com/vqhlecvy.json'
		  },
		  'Question Paper':{
			active:'https://cdn.lordicon.com/lordicon.js',
			inactive:'https://cdn.lordicon.com/udbbfuld.json'
		  },
		  'Usage Analytics': {
			active: "https://cdn.lordicon.com/qhkvfxpn.json",
			inactive: "https://cdn.lordicon.com/yxyampao.json"
		  },
		  'NAAC': {
			active: "https://cdn.lordicon.com/mrkkkqcr.json",
			inactive: "https://cdn.lordicon.com/tpxrxvnp.json"
		  },
		  'Student Queries': {
			active:"https://cdn.lordicon.com/jdgfsfzr.json",
			inactive:"https://cdn.lordicon.com/jdgfsfzr.json"
		  },
		  [this.displayNames.studentQuery]: {
			active:"https://cdn.lordicon.com/jdgfsfzr.json",
			inactive:"https://cdn.lordicon.com/jdgfsfzr.json"
		  },
		  'WebOPAC': {
			active:"https://cdn.lordicon.com/rpviwvwn.json",
			inactive:"https://cdn.lordicon.com/rpviwvwn.json"
		  },
		  'CMS': {
			active: "https://cdn.lordicon.com/jgnvfzqg.json",
			inactive: "https://cdn.lordicon.com/hqymfzvj.json"
		  },
		  'Mess Management' :{
			active :"https://cdn.lordicon.com/jhiqqftv.json",
			inactive:"https://cdn.lordicon.com/jhiqqftv.json"
		  },
		  'COE': {
			active: "https://cdn.lordicon.com/yrbmguoo.json",
			inactive: "https://cdn.lordicon.com/zrtfxghu.json"
		  },
		 'All Permissions': {
			active: "https://cdn.lordicon.com/rwtswsap.json",
			inactive: "https://cdn.lordicon.com/ijahpotn.json"
		  },
	      'Default Communication Template': {
			active: "https://cdn.lordicon.com/rwtswsap.json",
			inactive: "https://cdn.lordicon.com/ijahpotn.json"
		  },
		 'Default Attachment Template': {
			active: "https://cdn.lordicon.com/rwtswsap.json",
			inactive: "https://cdn.lordicon.com/ijahpotn.json"
		  },
		'Delete Entity Request': {
			active: "https://cdn.lordicon.com/rwtswsap.json",
			inactive: "https://cdn.lordicon.com/ijahpotn.json"
		  },
		'LMS': {
			active: "https://cdn.lordicon.com/wkyvrqoh.json",
			inactive: "https://cdn.lordicon.com/sqopewut.json"
		  },
		'Teacher MIS': {
			active: "https://cdn.lordicon.com/psnhyobz.json",
			inactive: "https://cdn.lordicon.com/psnhyobz.json"
		  },
		'Utilities': {
			active: "https://cdn.lordicon.com/boyoxams.json",
			inactive: "https://cdn.lordicon.com/ercyvufy.json"
		  },
		};

		let icon = iconMap[title];
		if (!icon && this.displayNames && this.displayNames.advanced && title === this.displayNames.advanced) {
			icon = iconMap['Advanced'];
		}
		return icon ? (isActive ? icon.active : icon.inactive) : null;
	  }


	  getIconColors(): string {
		return `primary:${this.primaryColour},secondary:${this.primaryColour}`;
	  }
	  toggleSlider() {
        this.isSliderOpen = !this.isSliderOpen;
    }
	onItemEnter(id: any) {
		this.hoveredMenuId = id;
	  }
	  
	  onItemLeave() {
		this.hoveredMenuId = null;
	  }
}
